import { observable, computed, action, configure } from 'mobx';
import axios from 'axios';

import config from './Config';

configure({ enforceActions: 'observed' }) // don't allow state modifications outside actions

class AuthenticationStore {
	@observable email = null;
	@observable token = null;
	@observable userId = null;
	@observable initializing = false;
	@observable loggingIn = false;

	@computed get isLogged() {
		return !!this.token;
	}


	static properties = ['email', 'token', 'userId'];

	constructor() {
		this.initialize();
	}

	getAuthHeadersValue(token) {
		return {
			// we can also use X-Access-Token
			'authorization': token
		}
	}

	getAuthHeaders() {
		return {
			// we can also use X-Access-Token
			headers: this.getAuthHeadersValue(this.token)
		}
	}

	@action initialize() {
		console.log('initializing...');
		let authData;
		try { authData = JSON.parse(localStorage.getItem('authData'));
		} catch(err){ console.error(err);
		}
		console.log(authData);
		if (!authData || !authData.token){ //TODO: also check if token is still valid by comparing the dates
			return;
		}
		this.initializing = true;
		// perform ajax operation...
		axios.get(config.apis.user.current, {
			headers: this.getAuthHeadersValue(authData.token)
		}).then( (user) => {
			console.log(user);
			console.log('still logged in...');
			this.setAccount(authData);
		}).catch( (err) => {
			console.error(err);
			localStorage.removeItem('authData');
		}).then( action(() => {
			this.initializing = false;
		}));
	}

	@action setAccount(data) {
		if (data === null){
			AuthenticationStore.properties.forEach( key => {
				this[key] = null;
			});
			return;
		}
		AuthenticationStore.properties.forEach( key => {
			this[key] = data.hasOwnProperty(key) ? data[key] : null;
		});
	}

	@action setLoggingIn(value) {
		this.loggingIn = value;
	}

	login(params) {
		//console.log(params);
		this.setLoggingIn(true);
		return axios.post(config.apis.user.login, {
			email: params.email
			,password: params.password
		}).then( (authResponse) => { //id, created, ttl, userId
			let authData = {
				email: params.email
				,token: authResponse.data.id
				,userId: authResponse.data.userId
			};
			this.setAccount(authData);
			localStorage.setItem('authData', JSON.stringify(authData));
			this.setLoggingIn(false);
		}).catch( (err) => {
			this.setLoggingIn(false);
			console.error('Error logging in', err);
			throw err;
		});
	}

	logout() { 
		return axios.post(config.apis.user.logout, null, {
			...this.getAuthHeaders()
		}).then( () => {
			this.setAccount(null);
			localStorage.removeItem('authData');
		});
	}

	requestPasswordReset(params) {
		console.log(`Requesting password reset for ${params.email}`);
		return axios.post(config.apis.user.requestPasswordReset, {
			email: params.email
		}).then( (response) => {
			console.log(response);
		});
	}

	resetPassword(params) {
		console.log(`resetting the password for token ${params.token}`);
		return axios.post(config.apis.user.resetPassword, {
			newPassword: params.password
		}, {
			headers: this.getAuthHeadersValue(params.token)
		}).then( (response) => {
			console.log(response);
		});
	}

}

export default AuthenticationStore;
